import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { SelectedRecipient } from '../order-sharing-modal/order-sharing-modal.component';

interface MemberNode {
  name?: string;
  city?: string;
  memberId?: number;
  contacts?: ContactNode[];
}

interface ContactNode {
  name?: string;
  contactId?: number;
  status?: 'PENDING' | 'SHARED';
  sharedByName?: string;
  dateShared?: string;
}

@Component({
  selector: 'app-selected-recipients',
  templateUrl: './selected-recipients.component.html',
  styleUrls: ['./selected-recipients.component.scss'],
  standalone: false,
})
export class SelectedRecipientsComponent implements OnInit, OnChanges {
  @Input() public selectedRecipients!: SelectedRecipient[];
  @Output() public removeRecipient: EventEmitter<SelectedRecipient> =
    new EventEmitter<SelectedRecipient>();

  protected dataSource!: MemberNode[];
  protected selectedContactsCount!: number;

  ngOnInit(): void {
    this.buildDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRecipients && !changes.selectedRecipients.firstChange) {
      this.buildDataSource();
    }
  }

  onRemove(member: MemberNode, contact: ContactNode): void {
    const idx: number = this.selectedRecipients?.findIndex(
      (sr: SelectedRecipient) =>
        sr.memberId === member.memberId && sr.contactId === contact.contactId,
    );
    if (idx > -1) {
      this.removeRecipient.emit(this.selectedRecipients[idx]);
    }
  }

  private buildDataSource(): void {
    this.dataSource = [];
    this.selectedContactsCount = this.selectedRecipients?.length;
    this.selectedRecipients?.forEach((contact: SelectedRecipient) => {
      const memberNode = this.dataSource.find(
        (member) => member.memberId === contact.memberId,
      );
      if (memberNode) {
        memberNode.contacts?.push({
          name: contact.contactName,
          contactId: contact.contactId,
          status: contact.status,
          sharedByName: contact.sharedByName,
          dateShared: contact.dateShared,
        });
      } else {
        this.dataSource.push({
          name: contact.memberName,
          city: contact.memberCity,
          memberId: contact.memberId,
          contacts: [
            {
              name: contact.contactName,
              contactId: contact.contactId,
              status: contact.status,
              sharedByName: contact.sharedByName,
              dateShared: contact.dateShared,
            },
          ],
        });
      }
    });
  }
}
